import { render, staticRenderFns } from "./SpecialSymbols.vue?vue&type=template&id=004a599d&"
import script from "./SpecialSymbols.vue?vue&type=script&lang=js&"
export * from "./SpecialSymbols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports